export default __webpack_public_path__ + "static/media/480_dummy2016-zahnarzt01-de.6c8fe4f1.png";